import { render, staticRenderFns } from "./Остатки по импорт.vue?vue&type=template&id=4f123edf&scoped=true"
import script from "./Остатки по импорт.vue?vue&type=script&lang=js"
export * from "./Остатки по импорт.vue?vue&type=script&lang=js"
import style0 from "./Остатки по импорт.vue?vue&type=style&index=0&id=4f123edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f123edf",
  null
  
)

export default component.exports